import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../../../styles/Subscription.module.scss";
import { APP_PATH, routePath } from "../../../routes/route";
import Input from "../../../components/core/Input/Input";
import useIsMobile from "../../../components/hooks/useIsMobile";
import Select from "../../../components/core/Select/Select";
import Button from "../../../components/core/Button/Button";
import useModalContext from "../../../components/core/Modal/useModalContext";
import tickIcon from "../../../assets/icons/tick_greencircle.svg";
import RedCrossImg from "../../../assets/icons/red-cross.svg";
import CustomIcon from "../../../components/core/CustomIcon/CustomIcon";
import { PLAN_URL } from "../../../config";
import classNames from "classnames";
import { COUNTRY_WITH_DIALCODES } from "../../../global/constant";
import { nanoid } from "nanoid";
import {
  isEmailValid,
  isMobileNumberValid,
  isOnlyAlphabets,
} from "../../../global/utility";
import { toast } from "react-toastify";
import arrow_down from "../../../assets/icons/chevron_arrow.svg";

const INDUSTRY_OPTIONS = [
  { value: "BFSIIndustry", label: "BFSI Industry" },
  { value: "TravelIndustry", label: "Travel Industry" },
  { value: "FoodIndustry", label: "Food Industry" },
  { value: "TextileIndustry", label: "Textile Industry" },
  { value: "AutomotiveIndustry", label: "Automotive Industry" },
  { value: "IronAndSteelIndustry", label: "Iron And Steel Industry" },
  { value: "Sugarindustry", label: "Sugar Industry" },
  { value: "CementIndustry", label: "Cement Industry" },
  {
    value: "ComputerInformationIndustry",
    label: "ComputerInformation Industry",
  },
  { value: "MedicalIndustry", label: "Medical Industry" },
  { value: "TelecomIndustry", label: "Telecom Industry" },
  { value: "AirlinesIndustry", label: "Airlines Industry" },
  { value: "Others", label: "Others" },
];

const COUNTRY_OPTIONS = [{ value: "India", label: "India" }];

const SubmitForm = ({ planName, planType }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile({ breakpoint: 625 });
  const modalContext = useModalContext();
  const [industryValue, setindustryValue] = useState("");
  const [countryValue, setcountryValue] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const openModal = (e, status, heading, subHeading, content) => {
    e.preventDefault();
    // console.log('openModal >>>>>>>>>>> ',status)
    modalContext.setBodyWithFooter(
      <ThankYouModal
        status={status}
        heading={heading}
        subHeading={subHeading}
        content={content}
      />
    );
    modalContext.setCloseIconVis(false);
    modalContext.setOnBackdropClick(() => closeModal);
    modalContext.setShow(true);
  };

  const closeModal = () => {
    modalContext.setShow(false);
  };

  const onIndustrySelect = (value) => {
    console.log("value", value);
    setindustryValue(value.target.value);
  };
  const onCountrySelect = (value) => {
    console.log("value", value);
    setcountryValue(value.target.value);
  };

  const handleDropdown = () => {
    setIsDropdownActive((prevState) => !prevState);
  };

  const handleOption = (dialCode) => {
    setCountryCode(dialCode);
    /* document
        .getElementById("countryCodeDropDown")
        .classList.remove(classes.active); */
    setIsDropdownActive((prevState) => !prevState);
  };

  const submitRequest = async (e) => {
    // console.log('submit Request 11111 >>>>>>> ',e)
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    // console.log('submit Request 22222 >>>>>>> ',data,countryValue,industryValue)
    // openModal(e)

    if (!isOnlyAlphabets(data.firstName) || !isOnlyAlphabets(data.lastName)) {
      toast("Enter only alphabets in name", {
        toastId: "NAME",
      });
      return;
    }

    if (!isEmailValid(data.emailId)) {
      toast("Enter valid email Id", {
        toastId: "EMAIL",
      });
      return;
    }

    if (!isMobileNumberValid(data.phoneNumber)) {
      toast("Enter valid mobile number", {
        toastId: "MOBILE",
      });
      return;
    }

    const payload = {
      firstName: data.firstName,
      lastName: data.lastName,
      emailId: data.emailId,
      mobile: data.phoneNumber,
      country: countryValue,
      company: data.company,
      industry: industryValue,
      planType: planType.toUpperCase(),
      planName: planName,
    };
    const headers = {
      "Content-Type": `application/json`,
    };
    // console.log('payload >>>>>>> ',payload)
    await fetch(`${PLAN_URL}/v1/sign-up`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: headers,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data, data.statusCode, data.status);
        if (data.statusCode === 2000) {
          // console.log('payload 222>>>>>>> ',data.statusCode)
          // const heading="Thank You!"
          // const subHeading="Your account is being validated."
          // const content="Upon approval, you will receive your login credentials via Email on your registered email ID."
          // openModal(e,2000,heading,subHeading,content)
          sessionStorage.setItem("showThankYouPage", true);
          sessionStorage.setItem("isFreeTrialThankyouPage", true);
          navigate(routePath.thankyou.path);
        } else if (data.statusCode === 4062) {
          // console.log('payload 3333>>>>>>> ',data.statusCode)
          const heading = "Your request already exist.";
          const subHeading = "";
          const content = data.message;
          openModal(e, 4061, heading, subHeading, content);
        } else {
          const heading = "Sorry!";
          const subHeading = "Error in request.";
          const content =
            "There is some error in request submission. Please try after some time";
          openModal(e, 4000, heading, subHeading, content);
        }
      })
      .catch((error) => {
        console.log("Error in submitting request >>>>>>> ");
      });
  };
  return (
    <>
      <form className={classes.form} onSubmit={submitRequest}>
        <div
          style={{
            display: "flex",
            gap: "16px",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Input
            label="First Name"
            isRequired={true}
            name="firstName"
            placeholder="Enter your first name"
          />
          <Input
            label="Last Name"
            isRequired={true}
            name="lastName"
            placeholder="Enter your last name"
          />
        </div>
        <Input
          label="Company"
          isRequired={true}
          name="company"
          placeholder="Enter your company name"
        />
        <Input
          label="Email ID"
          isRequired={true}
          name="emailId"
          placeholder="Enter your email ID"
        />
        {/* <Input
                    label="Phone Number"
                    isRequired={true}
                    name="phoneNumber"
                    placeholder="Enter your phone number"
                    /> */}

        <div style={{ position: "relative", cursor: "pointer" }}>
          <Input
            label="Phone number"
            placeholder="Enter your phone number"
            isRequired={true}
            /* width={isMobile ? "100%" : "65%"} */
            type="number"
            style={{ paddingLeft: "80px" }}
            name="phoneNumber"
          />

          <div className={classNames(classes.dropdown)}>
            <button
              className={classNames(classes.dropdowntoggle)}
              type="button"
              onClick={handleDropdown}
            >
              <div className={classNames(classes.dropdownitem)}>
                <div className={classes.countryCodeText}>{countryCode}</div>
                <CustomIcon src={arrow_down} alt="dropdown" />
              </div>
            </button>
            <ul
              className={classNames(
                classes.dropdownmenu,
                isDropdownActive ? classes.active : ""
              )}
              id="countryCodeDropDown"
              onMouseLeave={() => setIsDropdownActive(false)}
            >
              {COUNTRY_WITH_DIALCODES.map((option) => {
                return (
                  <li
                    key={nanoid()}
                    onClick={() => handleOption(option.dialCode)}
                  >
                    <div className={classes.countryCodeText}>
                      {option.dialCode}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <Select
          label="Primary country of operation"
          placeholder="Primary country of operation*"
          isRequired={true}
          name="primarycountryofoperation*"
          options={COUNTRY_OPTIONS}
          onChange={onCountrySelect}
          value={countryValue}
        ></Select>
        <Select
          label="Industry"
          placeholder="Enter your industry"
          isRequired={true}
          name="industry"
          options={INDUSTRY_OPTIONS}
          onChange={onIndustrySelect}
          value={industryValue}
        ></Select>
        {/* <button type="submit" style={{margin: "auto", marginTop: 16}}>Submit</button> */}
        <Button
          label="Submit"
          type="submit"
          stylebtn={{ margin: "auto", marginTop: 16 }}
          // clickHandler={(e) => submitRequest(e)}
        />
        <div className={classes.tnc}>
          By clicking “Submit”, I agree to Paytm Cloud Solutions Social’s
          <a onClick={() => navigate(`${APP_PATH}/termsofservice`)}>
            Terms of Service
          </a>
          and acknowledge its
          <a onClick={() => navigate(`${APP_PATH}/privacypolicy`)}>
            Privacy Policy
          </a>
          .
        </div>
      </form>
    </>
  );
};

const ThankYouModal = ({ status, heading, subHeading, content }) => {
  const navigate = useNavigate();
  const modalContext = useModalContext();
  const handlebuttonClick = () => {
    modalContext.setShow(false);
    navigate(`${APP_PATH}/home`);
  };
  console.log("ThankYouModal >>>>>>>>>>> ", status);
  return (
    <div className={classes.thankYouCont}>
      <CustomIcon
        src={status === 2000 || 4062 ? tickIcon : RedCrossImg}
        iconHeight={40}
        iconWidth={40}
      />
      <div className={classes.heading}>{heading}</div>
      {subHeading !== "" && (
        <div className={classes.subHeading}>{subHeading}</div>
      )}
      <div className={classes.content}>{content}</div>
      <Button
        label="Explore Our platforms"
        clickHandler={handlebuttonClick}
        stylebtn={{ margin: "auto", marginTop: "20px" }}
      />
    </div>
  );
};

export default SubmitForm;
